module.exports = __webpack_public_path__ + "img/PizzaMachtGlücklich.e7e85bec.jpg";